import type { FaireProductEntity } from "../../entity_types/product";

export const p_9ilqgzr15e: FaireProductEntity = {
  token: "p_9ilqgzr15e",
  type: "product",
  name: "Moroccan Cone Glassware Large - Amber",
  brandToken: "b_6xvu4qtx",
  brandName: "Verve Culture",
  imageUrl:
    "https://cdn.faire.com/fastly/a1e4c500b4cf4c25ce1220bd3328c6afbefbb8e53b0a583f7cfd9c091f4971aa.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b71b157f41b000772bd55631d7f7e09054dd458db380f8a82f44e34c57f19b64.jpeg",
    "https://cdn.faire.com/fastly/84c22145cc75956a05179ff15283753c226e0c82bfbdeeae04480afea1c02438.jpeg",
    "https://cdn.faire.com/fastly/a5035d6d023b53b4adc0511ef4b5b4b60acb27243c09407456a3ae1b72d82c82.jpeg",
    "https://cdn.faire.com/fastly/a6db4a9fbbd6509edad31830efbc85885f9ccedb1c5212139fba2264cba2d1d8.jpeg",
    "https://cdn.faire.com/fastly/1059779fff0ecd118c99f1db509a7e432723883a5dd21348ab7f8b0b60449305.jpeg",
    "https://cdn.faire.com/fastly/5936a308e5268eb5275d2ca4c5d8ba1a11e27d08bb0454a56e02019f623fb3ac.jpeg",
    "https://cdn.faire.com/fastly/84be0b11d448f908237eb1f7d1cd6a708dc4d26272af85602fc6563ca2fc5968.jpeg",
    "https://cdn.faire.com/fastly/a34b8b95f0a48e73301dbffdc785a329a63d496ae475559651afd8e886fcadbc.jpeg",
    "https://cdn.faire.com/fastly/530c485ec28fd2962803385ac68460d941b2cff1f9516dbc3fdc41694d0442b8.jpeg",
  ],
  priceDollars: 4.2,
  description:
    "**Packaged in sets of 6 - 24 single glasses in a master\n\nOur Moroccan glassware is made from recycled wine bottles, beer bottles, jars, or other glass containers. Slight variations in hue/color can arise due to variations in temperature, the amount of glass used, or even the artistic choices made during production. These differences contribute to the unique charm and character of each piece.\n\nThe sleek and simple design of these hand-blown cone-shaped glasses is a testament to the style and skill of the artisans who make them. Used for all types of beverages or as little vases to decorate each table setting, you will enjoy the feel of them in your hand as you toast the joys of the day. They're also beautiful as a floral vase, too!\n\nOur Moroccan glassware sets come in four distinct shades of transparent glass (Clear, Amber, Blue & Green). The handblown construction is evident in the bubbles suspended in the glass itself, and the organic forms that the vessels take.\n\nCapacity: 12 fl oz",
  tags: [],
  msrpDollars: 8.4,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-05T16:54:22.803Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
